let api = {
    tenant: {
        // 企业租户
        list: {
            'url': '/bases/tenant/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/tenant/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/tenant/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/tenant/update/',
            'method': 'PUT'
        },
    },
    users: {
        // 用户
        login: {
            'url': '/bases/login/',
            'method': 'POST'
        },
        codeLogin: {
            'url': '/bases/login/code',
            'method': 'POST'
        },
        owninfo: {
            'url': '/bases/userinfo/',
            'method': 'GET'
        },
        list: {
            'url': '/bases/user/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/user/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/user/create/',
            'method': 'POST'
        },
        upstatus: {
            'url': '/bases/user/status/update/',
            'method': 'PATCH'
        },
        update: {
            'url': '/bases/user/update/',
            'method': 'PATCH'
        },
        upe: {
            'url': '/bases/user/update/',
            'method': 'PUT'
        },
        upImg: {
            'url': '/bases/user/update/img/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/user/delete/',
            'method': 'DELETE'
        },
        find: {
            'url': '/bases/user/find/',
            'method': 'GET'
        },
        only: {
            'url': '/bases/user/only/',
            'method': 'GET'
        },
        passwd: {
            'url': '/bases/user/update/passwd/',
            'method': 'GET'
        },
        easy: {
            'url': '/bases/user/easy/bypage/',
            'method': 'GET'
        }
    },
    role: {
        // 角色
        list: {
            'url': '/bases/role/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/role/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/role/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/role/update/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/bases/role/delete/',
            'method': 'DELETE'
        }
    },
    permission: {
        // 权限
        list: {
            'url': '/bases/permission/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/permission/bypage/',
            'method': 'GET'
        },
        me: {
            'url': '/bases/permission/me/',
            'method': 'GET'
        },
        tree: {
            'url': '/bases/permission/list/tree/',
            'method': 'GET'
        },
    },
    posts: {
        // 职务
        list: {
            'url': '/bases/posts/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/posts/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/posts/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/posts/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/posts/delete/',
            'method': 'DELETE'
        }
    },
    department: {
        // 部门
        tree: {
            'url': '/bases/department/tree',
            'method': 'GET'
        },
        treelabel: {
            'url': '/bases/department/tree-label/',
            'method': 'GET'
        },
        list: {
            'url': '/bases/department/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/department/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/department/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/department/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/department/delete/',
            'method': 'DELETE'
        }
    },
    files: {
        // 文件
        list: {
            'url': '/bases/file/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/file/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/file/upload/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/file/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/file/delete/',
            'method': 'DELETE'
        }
    },
    message: {
        // 通知信息
        list: {
            'url': '/bases/message/',
            'method': 'GET'
        },
        count: {
            'url': '/bases/message/count/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/message/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/message/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/message/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/message/delete/',
            'method': 'DELETE'
        }
    },
    tags: {
        // 标签
        list: {
            'url': '/bases/tags/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/tags/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/tags/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/tags/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/tags/delete/',
            'method': 'DELETE'
        },
        taskrote: {
            'url': '/task/tags/task/',
            'method': 'GET'
        },
        find: {
            'url': '/bases/tags/find/',
            'method': 'GET'
        }
    },
    taskstate: {
        // 状态
        list: {
            'url': '/bases/taskstate/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/taskstate/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/taskstate/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/taskstate/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/taskstate/delete/',
            'method': 'DELETE'
        }
    },
    taskflow: {
        // 状态类型
        list: {
            'url': '/bases/taskflow/list/',
            'method': 'GET'
        },
        info: {
            'url': '/bases/taskflow/info/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/taskflow/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/taskflow/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/taskflow/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/taskflow/delete/',
            'method': 'DELETE'
        },
        stepsdel: {
            'url': '/bases/taskflow/steps/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/bases/taskflow/detail/',
            'method': 'GET'
        }
    },
    project: {
        // 项目
        total: {
            'url': '/project/total/list/',
            'method': 'GET'
        },
        list: {
            'url': '/project/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/project/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/project/create/',
            'method': 'POST'
        },
        update: {
            'url': '/project/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/project/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/project/find/',
            'method': 'GET'
        },
        info: {
            'url': '/project/info/',
            'method': 'GET'
        },
        count: {
            'url': '/project/count/',
            'method': 'GET'
        },
        done: {
            'url': '/project/done/ratio/',
            'method': 'GET'
        },
        delay: {
            'url': '/project/delay/ratio/',
            'method': 'GET'
        },
        sub: {
            'url': '/project/count/sub/',
            'method': 'GET'
        },
        start: {
            'url': '/project/flow/start/',
            'method': 'POST'
        },
        audit: {
            'url': '/project/flow/audit/',
            'method': 'POST'
        },
        find: {
            'url': '/project/find/',
            'method': 'GET'
        }
    },
    team: {
        // 团队
        list: {
            'url': '/project/team/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/project/team/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/project/team/create/',
            'method': 'POST'
        },
        update: {
            'url': '/project/team/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/project/team/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/project/team/find/',
            'method': 'GET'
        },
    },
    milepost: {
        // 里程碑
        smalllist: {
            'url': '/project/milepost/title/list/',
            'method': 'GET'
        },
        list: {
            'url': '/project/milepost/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/project/milepost/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/project/milepost/create/',
            'method': 'POST'
        },
        update: {
            'url': '/project/milepost/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/project/milepost/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/project/milepost/find/',
            'method': 'GET'
        },
    },
    task: {
        // 任务
        list: {
            'url': '/task/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/task/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/task/create/',
            'method': 'POST'
        },
        update: {
            'url': '/task/update/',
            'method': 'PUT'
        },
        priority: {
            'url': '/task/update/priority/',
            'method': 'PUT'
        },
        tags: {
            'url': '/task/update/tags/',
            'method': 'PATCH'
        },
        datatime: {
            'url': '/task/update/datatime/',
            'method': 'PUT'
        },
        project: {
            'url': '/task/update/project/',
            'method': 'PUT'
        },
        person: {
            'url': '/task/update/person/',
            'method': 'PUT'
        },
        status: {
            'url': '/task/update/status/',
            'method': 'PUT'
        },
        time: {
            'url': '/task/update/time/',
            'method': 'PUT'
        },
        iteration: {
            'url': '/task/update/iteration/',
            'method': 'PUT'
        },
        delete: {
            'url': '/task/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/task/detail/',
            'method': 'GET'
        },
        bydetail: {
            'url': '/task/detail/by/',
            'method': 'GET'
        },
        count: {
            'url': '/task/count/',
            'method': 'GET'
        },
        tagsratio: {
            'url': '/task/tags/rate/',
            'method': 'GET'
        },
        delay: {
            'url': '/task/delay/rate/',
            'method': 'GET'
        },
        tagslist: {
            'url': '/task/tags/list/',
            'method': 'GET'
        },
        find: {
            'url': '/task/list/find/',
            'method': 'GET'
        },
        export: {
            'url': '/task/list/export/',
            'method': 'GET'
        }
    },
    repo: {
        // 仓库
        list: {
            'url': '/repo/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/repo/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/repo/create/',
            'method': 'POST'
        },
        update: {
            'url': '/repo/delete/',
            'method': 'PUT'
        },
        default: {
            'url': '/repo/default/view/',
            'method': 'POST'
        }
    },
    notify: {
        // 动态
        list: {
            'url': '/task/notify/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/task/notify/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/task/notify/create/',
            'method': 'POST'
        },
        delete: {
            'url': '/task/notify/delete/',
            'method': 'DELETE'
        },
    },
    log: {
        list: {
            'url': '/bases/history/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/history/bypage/',
            'method': 'GET'
        }
    },
    idc: {
        list: {
            'url': '/cmdb/idc/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/idc/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/idc/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/idc/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/idc/delete/',
            'method': 'DELETE'
        },
    },
    host: {
        list: {
            'url': '/cmdb/host/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/host/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/host/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/host/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/host/delete/',
            'method': 'DELETE'
        },
        ecspull: {
            'url': '/cmdb/handle/ecs/',
            'method': 'GET'
        },
        count: {
            'url': '/cmdb/host/count/',
            'method': 'GET'
        },
    },
    dbhost: {
        list: {
            'url': '/cmdb/dbhost/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/dbhost/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/dbhost/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/dbhost/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/dbhost/delete/',
            'method': 'DELETE'
        },
        pull: {
            'url': '/cmdb/handle/rds/',
            'method': 'GET'
        },
        dbpull: {
            'url': '/cmdb/handle/rds/db/',
            'method': 'GET'
        },
    },
    dbase: {
        small: {
            'url': '/cmdb/dbase/list/small/',
            'method': 'GET'
        },
        list: {
            'url': '/cmdb/dbase/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/dbase/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/dbase/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/dbase/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/dbase/delete/',
            'method': 'DELETE'
        },
    },
    cabinet: {
        list: {
            'url': '/cmdb/cabinet/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/cabinet/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/cabinet/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/cabinet/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/cabinet/delete/',
            'method': 'DELETE'
        },
    },
    domain: {
        list: {
            'url': '/cmdb/domain/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/domain/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/domain/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/domain/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/domain/delete/',
            'method': 'DELETE'
        },
    },
    slb: {
        list: {
            'url': '/cmdb/slb/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/slb/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/slb/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/slb/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/slb/delete/',
            'method': 'DELETE'
        },
        pull: {
            'url': '/cmdb/handle/slb/',
            'method': 'GET'
        },
    },
    menu: {
        list: {
            'url': '/bases/menu/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/menu/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/menu/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/menu/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/menu/delete/',
            'method': 'DELETE'
        },
        tree: {
            'url': '/bases/menu/tree/',
            'method': 'GET'
        },
    },
    wiki: {
        list: {
            'url': '/wiki/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/wiki/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/wiki/create/',
            'method': 'POST'
        },
        update: {
            'url': '/wiki/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/wiki/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/wiki/detail/',
            'method': 'GET'
        },
    },
    weekly: {
        list: {
            'url': '/wiki/weekly/list/',
            'method': 'GET'
        },
        create: {
            'url': '/wiki/weekly/create/',
            'method': 'POST'
        },
        update: {
            'url': '/wiki/weekly/update/',
            'method': 'PUT'
        },
    },
    chapter: {
        tree: {
            'url': '/wiki/chapter/tree/',
            'method': 'GET'
        },
        list: {
            'url': '/wiki/chapter/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/wiki/chapter/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/wiki/chapter/create/',
            'method': 'POST'
        },
        update: {
            'url': '/wiki/chapter/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/wiki/chapter/delete/',
            'method': 'DELETE'
        }
    },
    account: {
        list: {
            'url': '/bigdata/account/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bigdata/account/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bigdata/account/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bigdata/account/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bigdata/account/delete/',
            'method': 'DELETE'
        }
    },
    quotation: {
        list: {
            'url': '/bigdata/quotation/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bigdata/quotation/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bigdata/quotation/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bigdata/quotation/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bigdata/quotation/delete/',
            'method': 'DELETE'
        }
    },
    config: {
        list: {
            'url': '/bases/conf/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/conf/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/conf/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/conf/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/conf/detail/',
            'method': 'GET'
        }
    },
    content: {
        update: {
            'url': '/wiki/content/update/',
            'method': 'PUT'
        },
    },
    app: {
        list: {
            'url': '/cicd/app/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cicd/app/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cicd/app/create/',
            'method': 'POST'
        },
        up: {
            'url': '/cicd/app/up/',
            'method': 'PUT'
        },
        update: {
            'url': '/cicd/app/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cicd/app/detail/',
            'method': 'GET'
        },
        // deploy: {'url': '/cicd/app/structure/', 'method': 'POST'},
        // logs: {'url': '/cicd/app/view/log/', 'method': 'GET'}
    },
    deploy: {
        count: {
            'url': '/cicd/deploy/count/',
            'method': 'GET'
        },
    },
    auth: {
        list: {
            'url': '/cicd/auth/list/',
            'method': 'GET'
        },
        create: {
            'url': '/cicd/auth/create/',
            'method': 'POST'
        },

    },
    plastify: {
        list: {
            'url': '/cmdb/plastify/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cmdb/plastify/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cmdb/plastify/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cmdb/plastify/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cmdb/plastify/delete/',
            'method': 'GET'
        }
    },
    cart: {
        list: {
            'url': '/cicd/cert/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cicd/cert/list//bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cicd/cert/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cicd/cert/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cicd/cert/detail/',
            'method': 'GET'
        },
    },
    release: {
        list: {
            'url': '/cicd/release/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cicd/release/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cicd/release/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cicd/release/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cicd/release/detail/',
            'method': 'GET'
        },
        deploy: {
            'url': '/cicd/release/deploy/',
            'method': 'POST'
        }
    },
    process: {
        list: {
            'url': '/cicd/process/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/cicd/process/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/cicd/process/create/',
            'method': 'POST'
        },
        update: {
            'url': '/cicd/process/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/cicd/process/detail/',
            'method': 'GET'
        }
    },
    instance: {
        monitor: {
            'url': '/cmdb/instance/monitor/',
            'method': 'GET'
        },
        soon: {
            'url': '/instance/ecs/soon/',
            'method': 'GET'
        }
    },
    flow: {
        list: {
            'url': '/bases/flow/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/flow/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/flow/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/flow/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/flow/delete/',
            'method': 'GET'
        },
        find: {
            'url': '/bases/flow/find/',
            'method': 'GET'
        }
    },
    flowBill: {
        list: {
            'url': '/bases/flowbill/',
            'method': 'GET'
        },
        bypage: {
            'url': '/bases/flowbill/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/bases/flowbill/create/',
            'method': 'POST'
        },
        update: {
            'url': '/bases/flowbill/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/bases/flowbill/delete/',
            'method': 'DELETE'
        }
    },
    work: {
        list: {
            'url': '/work/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/work/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/work/create/',
            'method': 'POST'
        },
        status: {
            'url': '/work/update/status/',
            'method': 'PUT'
        },
        update: {
            'url': '/work/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/work/delete/',
            'method': 'DELETE'
        },
        find: {
            'url': '/work/find/',
            'method': 'GET'
        },
        start: {
            'url': '/work/flow/start/',
            'method': 'POST'
        },
        audit: {
            'url': '/work/flow/audit/',
            'method': 'POST'
        },
        workexport: {
            'url': '/work/export/',
            'method': 'GET'
        },
        export: {
            'url': '/work/order/export/',
            'method': 'POST'
        }
    },
    workorder: {
        list: {
            'url': '/work/order/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/work/order/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/work/order/create/',
            'method': 'POST'
        },
        update: {
            'url': '/work/order/update/',
            'method': 'PUT'
        },
        status: {
            'url': '/work/order/update/status/',
            'method': 'PUT'
        },
        delete: {
            'url': '/work/order/delete/',
            'method': 'DELETE'
        },
        find: {
            'url': '/work/order/find/',
            'method': 'GET'
        },
        start: {
            'url': '/work/order/flow/start/',
            'method': 'POST'
        },
        audit: {
            'url': '/work/order/flow/audit/',
            'method': 'POST'
        }
    },
    comment: {
        list: {
            'url': '/work/comments/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/work/comments/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/work/comments/create/',
            'method': 'POST'
        },
        update: {
            'url': '/work/comments/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/work/comments/delete/',
            'method': 'GET'
        }
    },
    flowExe: {
        list: {
            'url': '/bases/flowexe/list/',
            'method': 'GET'
        },
    },
    grouping: {
        tree: {
            'url': '/test/group/tree/',
            'method': 'GET'
        },
        list: {
            'url': '/test/group/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/test/group/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/test/group/create/',
            'method': 'POST'
        },
        update: {
            'url': '/test/group/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/test/groupdelete/',
            'method': 'GET'
        }
    },
    cases: {
        list: {
            'url': '/test/cases/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/test/cases/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/test/cases/create/',
            'method': 'POST'
        },
        update: {
            'url': '/test/cases/update/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/test/cases/delete/',
            'method': 'DELETE'
        }
    },
    iteration: {
        list: {
            'url': '/task/iteration/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/task/iteration/list/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/task/iteration/create/',
            'method': 'POST'
        },
        update: {
            'url': '/task/iteration/update/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/task/iteration/delete/',
            'method': 'DELETE'
        },
        uptask: {
            'url': '/task/iteration/uptask/',
            'method': 'PATCH'
        },
        retask: {
            'url': '/task/iteration/retask/',
            'method': 'PATCH'
        },
        status: {
            'url': '/task/iteration/update/status/',
            'method': 'PUT'
        },
        done: {
            'url': '/task/iteration/update/done/',
            'method': 'PUT'
        }
    },
    planed: {
        list: {
            'url': '/test/planed/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/test/planed/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/test/planed/create/',
            'method': 'POST'
        },
        update: {
            'url': '/test/planed/update/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/test/planed/delete/',
            'method': 'DELETE'
        },
        detail: {
            'url': '/test/planed/detail/',
            'method': 'GET'
        }
    },
    testsheet: {
        list: {
            'url': '/test/sheet/list/',
            'method': 'GET'
        },
        export: {
            'url': '/test/sheet/export/',
            'method': 'GET'
        },
        bypage: {
            'url': '/test/sheet/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/test/sheet/create/',
            'method': 'POST'
        },
        update: {
            'url': '/test/sheet/update/',
            'method': 'PUT'
        },
        uptask: {
            'url': '/test/sheet/uptask/',
            'method': 'PATCH'
        },
        retask: {
            'url': '/test/sheet/retask/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/test/sheet/delete/',
            'method': 'DELETE'
        }
    },
    testrecord: {
        list: {
            'url': '/test/record/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/test/record/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/test/record/create/',
            'method': 'POST'
        },
        update: {
            'url': '/test/record/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/test/record/delete/',
            'method': 'DELETE'
        }
    },
    version: {
        list: {
            'url': '/version/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/version/bypage/',
            'method': 'GET'
        },
        create: {
            'url': '/version/create/',
            'method': 'POST'
        },
        update: {
            'url': '/version/update/',
            'method': 'PUT'
        },
        delete: {
            'url': '/version/delete/',
            'method': 'DELETE'
        },
        export: {
            'url': '/version/export/',
            'method': 'GET'
        }
    },
    library: {
        list: {
            'url': '/version/library/list/',
            'method': 'GET'
        },
        bypage: {
            'url': '/version/library/bypage/',
            'method': 'GET'
        },
        uptask: {
            'url': '/task/version/uptask/',
            'method': 'PATCH'
        },
        retask: {
            'url': '/task/version/retask/',
            'method': 'PATCH'
        },
        create: {
            'url': '/version/library/create/',
            'method': 'POST'
        },
        update: {
            'url': '/version/library/update/',
            'method': 'PATCH'
        },
        delete: {
            'url': '/version/library/delete/',
            'method': 'DELETE'
        },
        find: {
            'url': '/version/library/find/',
            'method': 'GET'
        },
        start: {
            'url': '/version/library/flow/start/',
            'method': 'POST'
        },
        audit: {
            'url': '/version/library/flow/audit/',
            'method': 'POST'
        }
    },

}

export default {
    api: api,
    prefix: '/api'
}